module.exports = __webpack_public_path__ + "static/media/video-perspective-taking-en.731b2528.vtt";